import { Box } from '@mui/material'
import React from 'react'
import HeroHeadline from '../../Components/HeroHeadline'
import PortfolioSlider from './PortfolioSlider'
import WorkingProcess from './WorkingProcess'
import PortfolioSection from './PortfolioSection'
import { outline3 } from '../../assets'
import Banner from './Banner'


const Portfolio: React.FC = () => {
  return (
    <Box>
      {/* <HeroHeadline backgroundImage={outline3}>
        <span data-outline>Trusted by industry leaders,</span>{" "}
        <span data-highlight> Backed by Reputation.</span>{" "}
        <span data-outline>Browse my</span>{" "}

        <span data-highlight>Portfolio </span>
        <span data-outline>of premium clients, </span>{" "}
        <span data-highlight> Milestones & Media Features. </span>


      </HeroHeadline> */}
      <Banner/>
      {/* <PortfolioSlider /> */}
      <PortfolioSection />
      {/* <WorkingProcess /> */}


    </Box>
  )
}

export default Portfolio
